module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.location) ? _c('div', [_c('md-card', [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("\n            " + _vm._s(_vm.location.name) + "\n            "), _c('span', [(_vm.$apollo.loading) ? _c('md-progress-bar', {
    attrs: {
      "md-mode": "query"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('md-icon', [_vm._v("location_on")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.location.address || "unknown address"))])], 1)]), _vm._v(" "), (_vm.isMine(_vm.location)) ? _c('md-menu', {
    attrs: {
      "md-size": "big",
      "md-direction": "bottom-end"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showEditLocationDialog = true
      }
    }
  }, [_c('span', [_vm._v("Edit")]), _vm._v(" "), _c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showConfirmDelete = true
      }
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-card-content', [_vm._v(_vm._s(_vm.location.description))]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-icon-button md-primary",
    on: {
      "click": _vm.newVenue
    }
  }, [_c('md-icon', [_vm._v("add_circle")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Add Venues")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.refetch
    }
  }, [_c('md-icon', [_vm._v("refresh")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Refetch location data")])], 1)], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('md-table', {
    attrs: {
      "md-fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "md-table-row",
      fn: function(ref) {
        var item = ref.item;

        return _c('md-table-row', {
          attrs: {
            "md-selectable": "single"
          }
        }, [_c('md-table-cell', {
          attrs: {
            "md-label": "Name"
          }
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Description"
          }
        }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Reservation"
          }
        }, [_vm._v(_vm._s(item.reservedBy))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Actions"
          }
        }, [_c('md-button', {
          staticClass: "md-icon-button",
          on: {
            "click": function($event) {
              _vm.deleteVenue(item.id)
            }
          }
        }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)], 1)
      }
    }]),
    model: {
      value: (_vm.location.venues),
      callback: function($$v) {
        _vm.$set(_vm.location, "venues", $$v)
      },
      expression: "location.venues"
    }
  }, [_c('md-table-toolbar', [_c('div', {
    staticClass: "md-toolbar-section-start"
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Venues")])])]), _vm._v(" "), _c('md-table-empty-state', {
    attrs: {
      "md-label": "No venues at this location"
    }
  }, [(_vm.currentUser) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.newVenue
    }
  }, [_vm._v("Add Venues")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('AddVenueDialog', {
    attrs: {
      "location": _vm.location,
      "show": _vm.showVenueDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showVenueDialog = false
      }
    }
  }), _vm._v(" "), _c('UpsertLocationDialog', {
    attrs: {
      "show": _vm.showEditLocationDialog,
      "location": _vm.location
    },
    on: {
      "onClose": function($event) {
        _vm.showEditLocationDialog = false
      }
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.showConfirmDelete,
      "md-title": "Delete location?",
      "md-content": "Delete the location and all its venues",
      "md-confirm-text": "Confirm",
      "md-cancel-text": "Cancel"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showConfirmDelete = $event
      },
      "md-confirm": _vm.deleteLocation
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ac083d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Location.vue
// module id = 442
// module chunks = 1